export const layout = {
  boxSizing: {
    scale: true,
  },
  display: {
    scale: true,
  },
  height: {
    scale: 'space',
  },
  isolation: {
    scale: true,
  },
  maxHeight: {
    scale: 'space',
  },
  maxWidth: {
    scale: 'space',
  },
  minHeight: {
    scale: 'space',
  },
  minWidth: {
    scale: 'space',
  },
  objectFit: {
    scale: true,
  },
  objectPosition: {
    scale: true,
  },
  overflow: {
    scale: true,
  },
  overflowX: {
    scale: true,
  },
  overflowY: {
    scale: true,
  },
  overscrollBehavior: {
    scale: true,
  },
  overscrollBehaviorX: {
    scale: true,
  },
  overscrollBehaviorY: {
    scale: true,
  },
  verticalAlign: {
    scale: true,
  },
  visibility: {
    scale: true,
  },
  width: {
    scale: 'space',
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Layout = typeof layout;
